export enum ListReportDisplayedAsValues {
    DISPLAYED_AS_LISTREPORT_OPTION_VALUE_DETAILEDTABLEVIEW = 0,
    DISPLAYED_AS_LISTREPORT_OPTION_VALUE_BLFVIEW_HORIZONTAL = 10,
    DISPLAYED_AS_LISTREPORT_OPTION_VALUE_BLFVIEW_VERTICAL = 11,
    DISPLAYED_AS_LISTREPORT_OPTION_VALUE_CHART_VIEW = 20
}

export enum WallboardDisplayedAsValues {
    DISPLAYED_AS_OPTION_VALUE_GRID = 0,
    DISPLAYED_AS_OPTION_VALUE_COLUMNS = 1,
    DISPLAYED_AS_OPTION_VALUE_ROWS = 2,
    DISPLAYED_AS_OPTION_VALUE_CHART = 10
}
